import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row card rounded-0" }
const _hoisted_3 = { class: "col-12 card-header" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-sm-12 col-md-6" }
const _hoisted_6 = ["value"]
const _hoisted_7 = ["value"]
const _hoisted_8 = ["value"]
const _hoisted_9 = ["value"]
const _hoisted_10 = ["value"]
const _hoisted_11 = ["value"]
const _hoisted_12 = ["value"]
const _hoisted_13 = ["value"]
const _hoisted_14 = ["value"]
const _hoisted_15 = ["value"]
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "col-sm-12 col-md-6" }
const _hoisted_18 = { class: "input-icons" }
const _hoisted_19 = { class: "col-12 card-body" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-10" }
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col-12" }
const _hoisted_28 = {
  key: 1,
  class: "row"
}
const _hoisted_29 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pagination = _resolveComponent("pagination")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.loading && !_ctx.err_msg)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "row card text-white rounded-0 top-header" }, [
            _createElementVNode("div", { class: "col-12 text-center" }, [
              _createElementVNode("h2", { class: "my-3 fw-bold" }, "User Management")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("button", {
                    class: "btn btn-sm btn-primary me-5 reset-btn",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.resetUsers()))
                  }, "Reset Filters"),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.role) = $event)),
                    onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getUsers()))
                  }, [
                    _cache[6] || (_cache[6] = _createElementVNode("option", { value: "0" }, "All Roles", -1)),
                    _createElementVNode("option", {
                      value: _ctx.UserRole.LEARNER
                    }, "Learners", 8, _hoisted_6),
                    _createElementVNode("option", {
                      value: _ctx.UserRole.SP
                    }, "Standardized Patients", 8, _hoisted_7),
                    _createElementVNode("option", {
                      value: _ctx.UserRole.OBSERVER
                    }, "Observers", 8, _hoisted_8),
                    _createElementVNode("option", {
                      value: _ctx.UserRole.TRAINER
                    }, "Trainers", 8, _hoisted_9),
                    _createElementVNode("option", {
                      value: _ctx.UserRole.REVIEWER
                    }, "Reviewers", 8, _hoisted_10),
                    _createElementVNode("option", {
                      value: _ctx.UserRole.AUTHOR
                    }, "Authors", 8, _hoisted_11),
                    _createElementVNode("option", {
                      value: _ctx.UserRole.HEADTRAINER
                    }, "Head Trainers", 8, _hoisted_12),
                    _createElementVNode("option", {
                      value: _ctx.UserRole.EXCLUDEFROMREPORTS
                    }, "Exclude From Reports", 8, _hoisted_13),
                    _createElementVNode("option", {
                      value: _ctx.UserRole.REPORTMANAGER
                    }, "Report Managers", 8, _hoisted_14),
                    _createElementVNode("option", {
                      value: _ctx.UserRole.ADMIN
                    }, "Admins", 8, _hoisted_15),
                    _createElementVNode("option", {
                      value: _ctx.UserRole.CLIENTADMIN
                    }, "Client Admins", 8, _hoisted_16),
                    _cache[7] || (_cache[7] = _createElementVNode("option", { value: "99" }, "Super Admins", -1))
                  ], 544), [
                    [_vModelSelect, _ctx.role]
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("i", {
                      class: "fas fa-search",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getUsers()))
                    }),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      placeholder: "search by email",
                      class: "float-end",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.email_string) = $event)),
                      onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.getUsers()), ["enter"]))
                    }, null, 544), [
                      [_vModelText, _ctx.email_string]
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              (_ctx.users.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users.slice(_ctx.page_start,_ctx.page_end), (user) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: user.id,
                          class: "col-6 user-mgmt-card mb-2 pt-2",
                          onClick: ($event: any) => (_ctx.router.push({name:'management.user',params:{user_id:user.id}}))
                        }, [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("img", {
                                src: user.image_location,
                                class: "rounded-circle float-start me-5",
                                width: "75"
                              }, null, 8, _hoisted_25),
                              _createElementVNode("h4", null, _toDisplayString(user.name), 1),
                              _createElementVNode("p", null, _toDisplayString(user.email), 1)
                            ]),
                            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "col-2 d-flex flex-column justify-content-center" }, [
                              _createElementVNode("h3", { class: "text-center" }, [
                                _createElementVNode("i", { class: "fas fa-arrow-circle-right text-primary float-end" })
                              ])
                            ], -1))
                          ]),
                          _cache[9] || (_cache[9] = _createElementVNode("hr", null, null, -1))
                        ], 8, _hoisted_22))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        (_ctx.users.length > 20)
                          ? (_openBlock(), _createBlock(_component_pagination, {
                              key: 0,
                              items: _ctx.users,
                              page_start: _ctx.page_start,
                              page_end: _ctx.page_end,
                              onNextPage: _ctx.nextPage,
                              onPreviousPage: _ctx.previousPage,
                              label: 'Users'
                            }, null, 8, ["items", "page_start", "page_end", "onNextPage", "onPreviousPage"]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : (!_ctx.initial)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, _cache[10] || (_cache[10] = [
                      _createElementVNode("div", { class: "col-12" }, " No users match search ", -1)
                    ])))
                  : _createCommentVNode("", true)
            ])
          ])
        ]))
      : (!_ctx.loading && _ctx.err_msg)
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _cache[12] || (_cache[12] = _createElementVNode("h4", null, "Error Loading Users", -1)),
            _createElementVNode("p", null, _toDisplayString(_ctx.err_msg), 1)
          ]))
        : _createCommentVNode("", true),
    _createVNode(_component_loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}